import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { BonusQualificationService } from './implementation/bonus-qualifications.service';
import { ConfigurationService } from './implementation/configuration.service';
import { DriverWigService } from './implementation/driver-wig.service';
import { PaymentService } from './implementation/payment.service';
import { IBonusQualificationService } from './interface/IBonusQualificationService';
import { IConfigurationService } from './interface/IConfigurationService';
import { IDriverWigService } from './interface/IDriverWigService';
import { IDriver360Service } from './interface/IDriver360Service';
import { IPaymentService } from './interface/IPaymentService';
import { MockBonusQulificationService } from './mock/mock-bonus-qualification.service';
import { MockConfigurationService } from './mock/mock-configuration.service';
import { MockDriverWigService } from './mock/mock-driver-wig.service';
import { MockPaymentnService } from './mock/mock-payment.service';
import { Driver360Service } from './implementation/driver360.service';
import { MockDriver360Service } from './mock/mock-driver360.service';
import { IDriverVOTService } from './interface/IDriverVOTService';
import { DriverVOT } from './implementation/drivervot.service';
import { MockDriverVOTService } from './mock/mock-drivervot.service';

@Injectable({
  providedIn: 'root',
})
export class ServiceFactory {
  constructor(private httpClient: HttpClient) {}

  public getBonusQualificationService(): IBonusQualificationService {
    if (window.__env.ngSettings.mock) {
      return new MockBonusQulificationService();
    } else {
      return new BonusQualificationService(this.httpClient);
    }
  }

  public getConfigurationService(): IConfigurationService {
    if (window.__env.ngSettings.mock) {
      return new MockConfigurationService();
    } else {
      return new ConfigurationService(this.httpClient);
    }
  }

  public getDriverWigService(): IDriverWigService {
    if (window.__env.ngSettings.mock) {
      return new MockDriverWigService();
    } else {
      return new DriverWigService(this.httpClient);
    }
  }

  public getPaymentService(): IPaymentService {
    if (window.__env.ngSettings.mock) {
      return new MockPaymentnService();
    } else {
      return new PaymentService(this.httpClient);
    }
  }

  public getDriver360Service(): IDriver360Service {
    if (window.__env.ngSettings.mock) {
      return new MockDriver360Service();
    } else {
      return new Driver360Service(this.httpClient);
    }
  }

  public getDriverVOTService(): IDriverVOTService {
    if (window.__env.ngSettings.mock) {
      return new MockDriverVOTService();
    } else {
      return new DriverVOT(this.httpClient);
    }
  }
}
